import { LIVE_LOCALES, DEFAULT_LOCALE } from './locales';

/**
 * The locale a visitor with no path segment should land on.
 *
 * Its own module because two very different callers need it and neither should
 * have to import the other: the router's `/` redirect, and the support launcher,
 * which resolves a language before React runs. While it lived in the route table
 * the launcher's `lang.ts` imported that table back — `routes → support-chat →
 * lang → routes`, a real ESM cycle that stayed harmless only because this was a
 * hoisted function declaration. Rewriting it as a const arrow, which is the
 * ordinary tidy-up, would have turned it into a TDZ crash at load.
 *
 * The order is the cookie the language switcher writes, then the browser's own
 * preference, then the default — the same order the funnel uses, so the two
 * cannot disagree about who a visitor is.
 */
export function guessMarketingLang(): string {
  const preferred =
    typeof document !== 'undefined'
      ? /(?:^|;\s*)pref_locale=([^;]+)/.exec(document.cookie)?.[1]
      : undefined;
  if (preferred && LIVE_LOCALES.some((l) => l.code === preferred)) return preferred;

  const nav = typeof navigator !== 'undefined' ? navigator.language?.toLowerCase() : '';
  const base = nav?.split('-')[0] ?? '';
  const match = LIVE_LOCALES.find((l) => l.code === nav || l.code === base);
  return match?.code ?? DEFAULT_LOCALE;
}
